import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import vueSmoothScroll from 'vue2-smooth-scroll'

// vee-validate (form validation)
Vue.use(VeeValidate, {
  events: ''
})

Vue.use(vueSmoothScroll)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
